import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/scout/qa/$runId')({
  component: QaLayout,
});

/**
 * QA layout — renders child routes via <Outlet />.
 * /scout/qa/$runId          → qa/$runId/index.tsx   (per-run review queue)
 * /scout/qa/$runId/summary  → qa/$runId/summary.tsx (session completion summary)
 */
function QaLayout() {
  return <Outlet />;
}
